<template>
    <b-field>
            <span class="button is-static is-small" :class="{ active: isActive }"><strong>{{carac.clef}} :</strong></span>
            <b-input  size="is-small" v-model="carac.valeur" @input="update" expanded></b-input>
            <b-button type="is-danger is-small"
                      icon-right="trash-alt" @click="deleteMe"></b-button>
            <b-button type="is-warning is-small"
                      icon-right="eye" @click="showMe"></b-button>
    </b-field>
</template>

<script>
    export default {
        name: 'tabltask',
        data (){
            return {
                carac:'',


            }
        },
        components: {},
        props: ['objet','lieu','letype'],
        computed: {
            getValue(){
                return Object.values(this.objet)[0]
            },
            getKey(){
                return Object.keys(this.objet)[0]
            },
            isActive(){
                let tmp=this.$store.getters.isSomeThingToShow;
                if(tmp===this.carac.clef)
                    return true
                else
                    return false
            }

        },
        methods: {
            async update(){
                await this.$mydb.do.saveCarac(this.carac)
                return true
            },

            async deleteMe()
            {
                await this.$mydb.do.deleteCarac(this.carac.id)
                this.$emit('deleteMe',this.objet)
                return true
            },

            showMe(){

                let tmp=this.$store.getters.isSomeThingToShow;
                //implementation d'un toggle
                if(tmp!==this.carac.clef){
                    this.$store.commit('SET_SHOWINGKEY',this.carac.clef)
                }
                else{
                    this.$store.commit('SET_SHOWINGKEY','')
                }
            }

        },
        async mounted(){
            const result=await this.$mydb.do.getCarac(this.letype,this.lieu,this.objet)

            // En fait, pour éviter d'avoir à coder des lignes de propagation
            //  quand une carac a été effacée d'un élément , la carac s'auto-détruit du state
            //  si elle ne se trouve pas elle meme

            if(result[0])
                this.carac=JSON.parse(JSON.stringify(result[0]))
            else
            {
                this.$emit('deleteMe',this.objet)
                this.$emit('reloadMe',this.objet)
            }


        }
    }

</script>


<style lang="scss">

    .myLabel{
        display:inline-block;
    }

    .lineField{
        width:100%;
        height:auto;
    }

    .active{
        color:white !important;
        background-color: red !important;
    }
</style>